import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const Video = createIcon({
  displayName: 'Video',
  viewBox: '0 0 32 32',
  path: [
    <svg fill="currentColor" key="video">
      <path
        clipRule="evenodd"
        d="M3.9998 6.39995H27.9998V25.6H3.99981L3.9998 6.39995ZM0.799805 6.39995C0.799805 4.63264 2.23249 3.19995 3.9998 3.19995H27.9998C29.7671 3.19995 31.1998 4.63264 31.1998 6.39995V25.6C31.1998 27.3673 29.7671 28.8 27.9998 28.8H3.99981C2.23249 28.8 0.799805 27.3673 0.799805 25.6V6.39995ZM21.0916 16.7044C21.6525 16.4023 21.6525 15.5977 21.0916 15.2956L13.179 11.035C12.646 10.748 11.9997 11.134 11.9997 11.7393V20.2606C11.9997 20.8659 12.646 21.252 13.179 20.965L21.0916 16.7044Z"
        fillRule="evenodd"
      />
    </svg>,
  ],
})
